// extracted by mini-css-extract-plugin
module.exports = {"listCard":"ListCard_list-card__1urER","arrow":"ListCard_arrow__Q75Dw","content":"ListCard_content__1HkWl","detailSubtext":"ListCard_detail-subtext__9zDoU"};